import { Box, Button, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { storeState } from '~/store'; // Importa o storeState para exibir o toast
import { StepTabsStyles } from './styles';

interface StepsTabProps {
  children: ReactNode;
  hasMembership?: boolean;
  setSelectedStep: (step: string) => void;
  selectedStep: string;
  canProceed: (currentStep: string) => boolean;
  onConfirmStep: (currentStep: string) => void; // Nova prop para confirmar o pagamento da etapa atual
  membershipFeeMethod: string;
  paymentStepsState: {
    [key: string]: boolean;
  };
}

export function StepsTab({
  children,
  hasMembership,
  selectedStep,
  setSelectedStep,
  canProceed,
  onConfirmStep: _onConfirmStep,
  membershipFeeMethod,
  paymentStepsState
}: StepsTabProps) {
  const theme = useTheme();
  const styles = StepTabsStyles(theme);

  const handleStepChange = (step: string) => {
    const stepsOrder = ['membership_fee', 'installments']; // Ordem das etapas
    const currentStepIndex = stepsOrder.indexOf(selectedStep);
    const targetStepIndex = stepsOrder.indexOf(step);

    if (targetStepIndex <= currentStepIndex || paymentStepsState[step]) {
      // Permite voltar ou avançar para etapas já concluídas
      setSelectedStep(step);
    } else if (canProceed(selectedStep)) {
      // Permite avançar se a etapa atual estiver concluída
      setSelectedStep(step);
    } else {
      storeState.addToast({
        title: 'Etapa incompleta',
        message: 'Você precisa completar a etapa atual antes de prosseguir.',
        type: 'error'
      });
    }
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.buttonContainer}>
        {/* Só exibe a aba de taxa de adesão se hasMembership for true E existir algum método de pagamento disponível */}
        {hasMembership && membershipFeeMethod !== '' && (
          <Button
            disabled={!hasMembership}
            variant="contained"
            sx={selectedStep === 'membership_fee' ? styles.buttonSelected : styles.button}
            onClick={() => handleStepChange('membership_fee')}
          >
            Taxa de adesão
          </Button>
        )}
        <Button
          variant="contained"
          sx={selectedStep === 'installments' ? styles.buttonSelected : styles.button}
          onClick={() => handleStepChange('installments')}
        >
          Mensalidade
        </Button>
      </Box>
      {children}
    </Box>
  );
}
